import { service } from '../../../../helpers/http' 

export const ActionGetCompanyBranches = ({ dispatch }, payload) => { 
    return service({
        module: 'domainCompanyBranch',
        action: 'getCompanyBranches',
        payload: payload
    })
}

export const ActionPostCompanyBranches = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompanyBranch',
        action: 'postCompanyBranches',
        payload: payload
    })
    
}

export const ActionPutCompanyBranches = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompanyBranch',
        action: 'putCompanyBranches',
        payload: payload
    })
    
}

export const ActionDeleteCompanyBranches = ({ dispatch }, payload) => {

    return service({
        module: 'domainCompanyBranch',
        action: 'deleteCompanyBranches',
        payload: payload
    })
    
}
